export default __webpack_public_path__ + "static/media/moonozTag.0dc1044b.svg";